import React from "react";
import { Link } from "react-router-dom";
import {
  Home,
  Top,
  Container,
  Logos,
  Content,
  Left,
  Right,
  Button,
  MessageFirstAccess,
  AlertMessageFirstAccess,
} from "./styles";
import LogoPodeMorar from "../../assets/landingPage/LogoPodeMorar.svg";
// import Logomarcas from "../../assets/landingPage/Logomarcas.svg";

import BG from "../../assets/landingPage/BgLp.png";
// import DecorationShapes from "../../assets/landingPage/Shapes.svg";
import { ReactComponent as Arrow } from "../../assets/landingPage/arrow.svg";
import Direcional from "../../assets/logos/Logo2 (1).png";
import Riva from "../../assets/logos/Camada_x-1@2x.png";
import AppStoreComponent from "./AppStore";

const BannerDesligamentoPortal = ({ handleShowBanner }) => {
  return (
    <Home>
      <Container>
        {/* <img src={DecorationShapes} className="shapes" alt="" /> */}
        <Top>
          <Logos>
            <div>
              <img src={LogoPodeMorar} alt="PodeMorar" />
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "row",
                }}
              >
                <img src={Direcional} alt="Direcional/Riva" />
                <img src={Riva} alt="Direcional/Riva" />
              </div>
            </div>
          </Logos>
          <AppStoreComponent landingPage />
        </Top>
        <Content>
          <Left>
            <h1>
              Bem vindo ao Pode <span>Morar</span>
            </h1>

            <div className="cta">
              <Button
                principal
                onClick={() => handleShowBanner()}
                id="btnAcessarMinhaConta"
              >
                acessar minha conta
                <Arrow />
              </Button>
              <div>
                <MessageFirstAccess>
                  Usuários que já realizaram o &quot;Primeiro acesso&quot;.
                </MessageFirstAccess>
              </div>
            </div>
            <div className="cta">
              <Link to="/primeiro-acesso" style={{ textDecoration: "none" }}>
                <Button>
                  *primeiro acesso
                  <Arrow />
                </Button>
              </Link>
              <AlertMessageFirstAccess>
                <strong className="important">*MUITO IMPORTANTE</strong>
                <p>
                  Para validar sua conta no novo portal (Pode morar) todos{" "}
                  <br /> os{" "}
                  <strong>
                    usuários devem realizar a etapa de &quot;Primeiro
                    Acesso&quot;.
                  </strong>
                </p>
              </AlertMessageFirstAccess>
            </div>
          </Left>
          <Right>
            <img style={{ width: "92%" }} src={BG} alt="" />
          </Right>
        </Content>
        {/* banner <button onClick={() => handleShowBanner()}>ok ok ok </button> */}
      </Container>
    </Home>
  );
};

export default BannerDesligamentoPortal;
